<template>
    <draggable class="dragArea" tag="ul" @end="processItemMove"  :list="items"
        :group="{ name: 'g1' }" item-key="name" :data-id="id" >
        <template #item="{ element }">
            <li class="cursor-pointer border-t border-gray-300 relative bg-white" :data-id="element.id" :data-type="type"
                :class="{ 'bg-gray-50': element.type === 'folder', 'bg-white': element.type === 'service' }, parentFolderID(element)">
                <div :id="'item-' + element.id" class="flex grid grid-cols-24 items-center w-full items-stretch">
                    <div
                        class="cursor-pointer px-1 py-3  flex justify-center items-center  border-r whitespace-nowrap text-xs  text-gray-900" :class="approvedColumnClass(element)">
                        <input type="checkbox"
                            @change="updateBatchItem(element.type, element.batch_children ?? element.id, $event)"
                            value="1" :id="element.type + '-' + element.id"
                            :data-folderopen="true"
                            class="h-4 w-4 text-amaze-coral focus:ring-amaze-coral border-gray-300 rounded">
                    </div>
                    <div v-if="element.type === 'folder'" @contextmenu="onContextMenu($event, quote, element)"
                        class="group flex flex-grow col-span-4 items-center hover:cursor-grab active:cursor-grabbing justify-between px-1 py-3 whitespace-normal text-xs text-gray-900 border-r"
                        :class="approvedColumnClass(element)">
                        <div class="flex  items-center" >
                            <FolderRemoveIcon class="w-4 h-4 mr-3" @click="toggleFolder(element)" v-if="element.isopen == undefined || element.isopen == true"></FolderRemoveIcon>
                            <FolderAddIcon class="w-4 h-4 mr-3" @click="toggleFolder(element)" v-if="element.isopen == false"></FolderAddIcon>
                            <span class="underline" @click="editFolder(element)">{{ element.name }}</span>
                        </div>
                        <!--                        <div class="flex flex-grow gap-2 invisible group-hover:visible"-->
                        <!--                             v-if="quote.status !== 'Confirmed'">-->
                        <!--                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Create New Folder">-->
                        <!--                                <FolderAddIcon alt="Create New Folder" @click="createFolder(quote.id, element.id)"-->
                        <!--                                               class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></FolderAddIcon>-->
                        <!--                            </Popper>-->
                        <!--                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Remove Folder">-->

                        <!--                                <FolderRemoveIcon alt="Remove Folder" @click="deleteFolder(element.id)"-->
                        <!--                                                  class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></FolderRemoveIcon>-->
                        <!--                            </Popper>-->
                        <!--                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Create New Service">-->

                        <!--                                <DocumentAddIcon alt="Add New Service" @click="createService(element.id)"-->
                        <!--                                                 class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></DocumentAddIcon>-->
                        <!--                            </Popper>-->
                        <!--                        </div>-->
                    </div>
                    <div v-if="element.type === 'service'" @contextmenu="onContextMenu($event, quote, element)"
                        class="group flex flex-grow col-span-4 items-center hover:cursor-grab active:cursor-grabbing justify-between px-1 py-3 whitespace-normal text-xs text-gray-900 border-r"  @click="editService(element)"  :class="approvedColumnClass(element)">
                        <div class="flex items-center">
                            <SelectorIcon class="w-4 h-4 mr-3"></SelectorIcon>
                            <span class="underline">{{ element.name }}</span>
                        </div>
                        <!--                        <div class="flex gap-2 invisible group-hover:visible" v-if="quote.status !== 'Confirmed'">-->
                        <!--                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Remove Service">-->

                        <!--                                <DocumentRemoveIcon alt="Remove Service" @click="deleteService(element.id)"-->
                        <!--                                                    class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></DocumentRemoveIcon>-->
                        <!--                            </Popper>-->
                        <!--                        </div>-->
                    </div>
                    <div class="flex items-center text-center px-1 py-3 text-xs text-gray-900 border-r" :class="normalColumnClass(element)">
                        <span v-if="element.starts_at">
                            {{ moment(element.starts_at, 'YYYY-MM-DD').format('DD/MM/YY') }}
                        </span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center text-center px-1 py-3 text-xs text-gray-900 border-r" :class="normalColumnClass(element)">
                        <span v-if="element.ends_at">
                            {{ moment(element.ends_at, 'YYYY-MM-DD').format('DD/MM/YY') }}
                        </span>

                        <span v-else>&nbsp;</span>
                    </div>
                    <div v-if="element.type === 'service'"
                        class="flex items-center px-1 py-3 col-span-2 text-xs text-gray-900 border-r underline"
                        :class="[{ 'bg-red-100': !element.supplier }, normalColumnClass(element)]">
                        <a target="_blank" :href="route('frontend.organisations.suppliers.organisation.show', element.supplier.id)" v-if="element.supplier">{{ element.supplier.name }}</a>
                        <span v-else class="flex">
                            <ShieldExclamationIcon class="w-4 h-4 mr-1 text-yellow-600"></ShieldExclamationIcon>
                            Add Supplier
                        </span>
                    </div>
                    <div v-else class="flex items-center px-1 py-3 col-span-2 text-xs text-gray-900 border-r">&nbsp;</div>
                    <div class="items-center px-1 py-3 text-xs text-gray-900 border-r col-span-3" v-html="element.description"  :class="normalColumnClass(element)"></div>
                    <div class="flex items-center px-1 py-3 text-xs text-center text-gray-900 border-r border-gray-300 justify-center"  :class="sellColumnClass(element)">
                        <span v-if="element.type === 'service'">{{
                        formatCurrency(element.calculated_sell_price, project.bank_account.currency.code, show_currency_code) }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center px-1 py-3 text-xs text-center text-gray-900 border-r border-gray-300 justify-center" :class="sellColumnClass(element)">
                        <span v-if="element.type === 'service'">{{ number_format(parseFloat(element.sell_unit)) ?? ''
                        }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div
                        class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r border-gray-300 justify-center" :class="sellColumnClass(element)">
                        <span v-if="element.type === 'service'">{{ number_format(parseFloat(element.sell_no)) }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div
                        class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r  border-gray-300 justify-center" :class="sellColumnClass(element)">
                        <span v-if="element.type === 'service'">{{
                        number_format(parseFloat(element.sell_vat_percentage).toFixed(2)) }}%</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="[{'font-medium': element.type === 'folder'}, sellColumnClass(element)]" >
                        {{ formatCurrency(element.sell_total, project.bank_account.currency.code, show_currency_code) }}
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="buyColumnClass(element)">
                        <span v-if="element.type === 'service'">{{
                        formatCurrency(element.calculated_buy_price, quote.buy_currency.code, show_currency_code) }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="buyColumnClass(element)">
                        <span v-if="element.type === 'service'">{{ number_format(parseFloat(element.buy_unit)) }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="buyColumnClass(element)">
                        <span v-if="element.type === 'service'">{{ number_format(parseFloat(element.buy_no)) }}</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="buyColumnClass(element)">
                        <span v-if="element.type === 'service'">{{
                        number_format(parseFloat(element.buy_vat_percentage).toFixed(2)) }}%</span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="flex items-center relative px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="[{'font-medium': element.type === 'folder'}, buyColumnClass(element)]">
                        {{ formatCurrency(element.buy_total, quote.buy_currency.code, show_currency_code) }}
                        <span class="absolute right-0 top-0 mr-1 mt-1" v-if="element.commission_amount > 0">
                    <svg class="w-3 h-3 text-green-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
  <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
</svg>                </span>
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 border-r justify-center" :class="profitColumnClass(element)">{{
                        formatCurrency(element.profit, project.bank_account.currency.code)
                    }}
                    </div>
                    <div class="flex items-center px-1 py-3 whitespace-nowrap text-xs text-center text-gray-900 justify-center" :class="profitPercentageColumnClass(element)">
                        {{ number_format(parseFloat(element.profit_percentage).toFixed(2)) }}%
                    </div>
                </div>

                <NestedDraggable v-if="element.services !== null && element.type === 'folder'" type="service"  :project="project" :id="null"
                    :quote="quote" :items="element.services" :show_currency_code="show_currency_code" />
                <NestedDraggable v-if="element.folders !== 'undefined'" :project="project" type="folder" :id="'folder-' + element.id"
                                 :quote="quote" :items="element.folders" :show_currency_code="show_currency_code" />
            </li>
        </template>
    </draggable>

</template>
<script>
import draggable from "vuedraggable";
import {
    FolderIcon,
    SelectorIcon,
    FolderAddIcon,
    FolderRemoveIcon,
    DocumentAddIcon,
    DocumentRemoveIcon,
    ShieldExclamationIcon
} from "@heroicons/vue/outline";
import { emitter } from "@/eventHub";
import moment from "moment";
import Popper from "vue3-popper";
import { h, reactive } from "vue";
import ContextMenu from "@imengyu/vue3-context-menu";

export default {
    props: {
        items: null,
        id: {
            required: false,
            default: null
        },
        type: {
            required: true,
            default: 'folders'
        },
        quote: {
            required: true
        },
        project: {
            required: true
        },
        show_currency_code: null
    },

    created() {
        this.moment = moment
    },
    components: {
        draggable,
        FolderIcon,
        SelectorIcon,
        FolderAddIcon,
        FolderRemoveIcon,
        DocumentAddIcon,
        DocumentRemoveIcon,
        Popper,
        ShieldExclamationIcon
    },
    name: "nested-draggable",
    methods: {
        editFolder(folder) {
            emitter.emit("openFolderSlideout", folder);
        },
        editService(service) {
            emitter.emit("openServiceSlideout", service);
        },
        createFolder(quote_id, folder_id) {
            emitter.emit("createFolderSlideout", {quote_id: quote_id, folder_id: folder_id})
        },
        createService(folder_id) {
            emitter.emit("createServiceSlideout", folder_id)
        },
        deleteFolder(folder_id) {
            emitter.emit("deleteFolder", folder_id)
        },
        deleteService(service_id) {
            emitter.emit("deleteService", service_id)
        },
        approveService(service_id) {
            emitter.emit("approveService", service_id)
        },
        unapproveService(service_id) {
            emitter.emit("unapproveService", service_id)
        },

        processItemMove(event) {

            // ID of the moved item.
            var item_id = event.item.dataset.id;
            var item_type = event.item.dataset.type;

            // ID of the new parent ul folder.
            var parent_id = event.to.parentElement.dataset.id
            var parent_type = event.to.parentElement.dataset.type;


            if (item_type === 'folder' && parent_type === 'service' || item_type === 'service' && parent_type === 'service') {
                this.$swal.fire({
                    title: 'Invalid Operation',
                    html: "The item you are trying to move cannot be placed here.",
                    timer: 1500,
                    timerProgressBar: true
                }).then(()=>{
                    if(item_type === 'folder' && parent_type === 'service') {
                        window.location.reload();
                    }

              })

            } else {
                emitter.emit("processItemMove", event)
            }

        },
        updateBatchItem(type, item, event) {
            if (type === 'folder') {
                if (item.length > 0) {
                    item.forEach(function (item) {
                        var element = document.getElementById(item);
                        element.checked = event.target.checked;
                        var id = item.split('-');
                        if (id[0] === 'service') {
                            emitter.emit("updateBatchItems", {item: id[1], isChecked: event.target.checked});
                        }
                    })
                }
            } else {
                emitter.emit("updateBatchItems", {item: item, isChecked: event.target.checked});
            }
        },
        updateItemMove(event) {

        },
        clone({id}) {
        },
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
        copy(data) {
            // Store the element id and type in the global state
            localStorage.setItem('clipboard', JSON.stringify(data));
            this.$swal.fire({
                title: data.type.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase()) + ' copied.',
                html: 'You have copied a ' + data.type + ', right click on a folder and click paste to import it to any project.',
                icon: 'success',
                showConfirmButton: false,
                toast: true,
                position: 'top-right',
                timer: 10000,
                timerProgressBar: true,
            });
        },
        paste(parent) {
            // Get the element type and id from state.
            let clipboard = JSON.parse(localStorage.getItem('clipboard')) ?? null

            // If there is no data in the clipboard, fire a message to the user informing them.
            if (clipboard === null) {
                this.$swal.fire({
                    title: 'Unable to paste.',
                    html: 'There are no items copied for you to paste.',
                    icon: 'error',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-right',
                    timer: 10000,
                    timerProgressBar: true,
                });
            }

            // If the parent element is a service, we can't add a child so we need to handle this.
            if (parent.type === 'service') {
                this.$swal.fire({
                    title: 'Unable to copy ' + clipboard.type + ' to this service.',
                    html: 'Folders and services cannot be a child of a service. Please copy a service or folder into an existing folder.',
                    icon: 'error',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-right',
                    timer: 10000,
                    timerProgressBar: true,
                });
                return false;
            }

            // Perform a request to the server to copy the service or folder within the clipboard to the selected service.
            this.$inertia.post(route('frontend.project.quote.paste', [this.quote.project_id, parent.quote_id]), {
                parent_id: parent.id,
                parent_type: parent.type,
                id: clipboard.id,
                type: clipboard.type
            });

            localStorage.removeItem('clipboard');
        },

        onContextMenu(e, quote, element) {
            //prevent the browser's default menu
            e.preventDefault();
            var contextMenuItems;

            if (element.type === 'folder') {
                contextMenuItems = [
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Add Subfolder"),
                        onClick: () => this.createFolder(quote.id, element.id),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Add Service"),
                        onClick: () => this.createService(element.id),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Copy"),
                        onClick: () => this.copy({'type': 'folder', 'id': element.id}),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Paste"),
                        onClick: () => this.paste(element),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                                color: '#EAB308',
                            }
                        }, "Edit Folder"),
                        onClick: () => this.editFolder(element),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                                color: '#ff0000',
                            }
                        }, "Remove Folder"),
                        onClick: () => this.deleteFolder(element.id),
                    },
                ]
            }

            if (element.type === 'service') {
                contextMenuItems = [
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Edit Service"),
                        onClick: () => this.editService(element),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                                color: '#EAB308',
                            }
                        }, element.is_approved === 1 ? "Unapprove" : "Approve"),
                        onClick: () => element.is_approved === 1 ? this.unapproveService(element.id) : this.approveService(element.id),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Copy"),
                        onClick: () => this.copy({'type': 'service', 'id': element.id}),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                            }
                        }, "Paste"),
                        onClick: () => this.paste(element),
                    },
                    {
                        label: h('span', {
                            style: {
                                fontSize: '12px',
                                color: '#ff0000',
                            }
                        }, "Remove Service"),
                        onClick: () => this.deleteService(element.id),
                    },
                ]
            }

            var parent_id = document.getElementById('item-' + element.id);
            var rect = e.target.getBoundingClientRect();

            this.$contextmenu({
                items: contextMenuItems,
                iconFontClass: 'iconfont',
                zIndex: 3,
                minWidth: 230,
                fontSize: '12px',
                x: e.x,
                y: e.target.getBoundingClientRect().top + document.documentElement.scrollTop,
            });

        },

        profitColumnClass(element) {
            if (element.type === 'service') {
                if (element.is_invoiced) {
                    return 'bg-gray-200'
                } else if (element.profit > 0) {
                    return 'bg-green-100'
                } else if(element.profit < 0) {
                    return 'bg-red-200'
                }
            }
        },
        profitPercentageColumnClass(element) {
            if (element.type === 'service') {
                if (element.is_invoiced) {
                    return 'bg-gray-200'
                } else if (element.profit_percentage > 0) {
                    return 'bg-green-100'
                } else if(element.profit_percentage < 0) {
                    return 'bg-red-200'
                }
            }
        },
        approvedColumnClass(element) {
            if (element.type === 'service') {
                if (element.is_approved) {
                    return 'bg-yellow-200'
                }
            }
        },
        normalColumnClass(element) {
            if (element.type === 'service') {
                if (element.is_invoiced) {
                    return 'bg-gray-200'
                } else if (element.is_approved) {
                    return 'bg-yellow-200'
                }
            }
        },

         buyColumnClass(element) {
            if (element.type === 'service') {
                return 'bg-red-100'
            }
            return '';
        },
        sellColumnClass(element) {
            if (element.type === 'service') {
                return 'bg-blue-100'
            }
            return '';
        },
        parentFolderID(element) {
            if (element.type === 'folder' && element.parent_id !== null) {
                return 'folder-' + element.parent_id;
            } else if (element.type === 'service' && element.folder_id !== null) {
                return 'folder-' + element.folder_id;
            }
            return '';
        },
        toggleFolder(element) {
            var folder = document.getElementById("folder-" + element.id );
            var isOpen = folder.getAttribute('date-folderopen');
            if(isOpen === "false") {
                //  Close the folder and hide it's child elements.
                var services = document.getElementsByClassName('folder-' + element.id);
                for (let item of services) {
                    item.classList.remove('hidden');
                }
                folder.setAttribute('date-folderopen', true);
                element.isopen = true;
            } else {
                //  Close the folder and hide it's child elements.
                var services = document.getElementsByClassName('folder-' + element.id);
                for (let item of services) {
                    item.classList.add('hidden');
                }
                // Set the folder to closed.
                folder.setAttribute('date-folderopen', false);
                element.isopen = false;
            }
        }
    }
};
</script>
